import { FleetConfiguration } from './FleetConfiguration';
import { FleetConstantClassCollection } from "./FleetConstantClassCollection";

export class UpdateFleetConfigurationDialogData {
    fleetConfigurationDefaults?: FleetConfiguration;
    fleetConstantClassCollection?: FleetConstantClassCollection;
}